import { render, staticRenderFns } from "./Resolved.vue?vue&type=template&id=ed72ec3e&"
import script from "./Resolved.vue?vue&type=script&lang=js&"
export * from "./Resolved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports